import { Type } from '@sinclair/typebox';
export const AssetData = Type.Object({
    wizard_icon: Type.Optional(Type.String()),
    available: Type.Optional(Type.Boolean()),
}, { additionalProperties: true });
export const AssetResponseSchema = Type.Object({
    id: Type.Number(),
    attributeId: Type.Number(),
    attributeName: Type.String(),
    metadata: Type.Optional(Type.Record(Type.String(), AssetData)),
});
export const CreateAssetSchema = Type.Omit(AssetResponseSchema, ['id', 'attributeName']);
export const UpdateAssetSchema = Type.Partial(CreateAssetSchema);
//# sourceMappingURL=assets.js.map